export const CHANNEL_SETTING_PREFIX: string = 'Channel_';